// import { getCookie } from '@/utils/cookie'

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export function getToken() {
  return getCookie('jwt_token') || null;
}
